import ScreensaverLayout from '../../components/pages/ScreensaverFlipped';
import themes from '../../themes';

export default function Screensaver() {
  return <ScreensaverLayout station={'bohren'} theme={themes.bohren} rotations={{ root: 270 }}/>;
}
